import React, { useState } from "react";
import { Button } from "components/common";

const SetCreditLimitModal = ({ closeModal, setCreditLimit, user_id }) => {
  const [newLimit, setNewLimit] = useState(0);
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  console.log('opening set credit limit modal');

  return (
    <div style={{ backgroundColor: "#FAFAFA" }} className="py-8 px-12">
      <span className="mb-5 w-1/4">New Spending Power</span>
      <input
        type="number"
        className="mb-5 w-3/4 p-2"
        onChange={e => setNewLimit(e.target.value)}
      />
      <div>Reason for this change:</div>
      <textarea
        className="w-full mb-5 p-2"
        onChange={e => setReason(e.target.value)}
        style={{ height: "100px", width: "100%" }}
      />
      <div className={errorMessage ? "text-red-600 mb-4" : "hidden"}>
        {errorMessage}
      </div>
      <div className="text-center">
        <button type="button" onClick={closeModal}>
          Cancel
        </button>
      </div>
      <Button
        className={`mb-6 w-full ${loading ? "opacity-50" : ""}`}
        disabled={loading}
        onClick={() => {
          setLoading(true);
          setCreditLimit(
            {
              variables: {
                user_id,
                reason,
                new_limit: parseInt(newLimit)
              }
            }).then(() => {
              // go to success scenario
              closeModal();
              setLoading(false);
            }).catch(e => {
              // go to failure scenario
              setErrorMessage(
                "Failed to set spending power, please try again later."
              );
              setLoading(false);
            });
        }}
      >
        Submit
      </Button>
    </div>
  );
};

export default SetCreditLimitModal;
